module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((!_vm.areAnyExercises || _vm.seznamPodskupin.length > 0) && _vm.adminView) ? _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.adminpanel.exercises.bannerName")))]), _vm._v(" "), (_vm.detectMobile()) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm createBtn btn-margin col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseCreateSubgroup(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.createSubGroup')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm createBtn btn-margin col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddExam($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.exams.createExam')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm createBtn btn-margin col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleReorderSubgroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.reorder')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm createBtn btn-margin col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.recomputeGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.exportGroup')))])]) : (_vm.toggleStatus) ? _c('div', {
    staticClass: "pull-right"
  }, [(_vm.statusProgress == -1) ? _c('div', {
    staticClass: "text-red"
  }, [(_vm.statusType === 'YAML import') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.yamlError')))]) : (_vm.statusType === 'Recompute group') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.recomputeError')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDetailsModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.details')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refreshGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.back')))])]) : (_vm.statusProgress == 100) ? _c('div', {
    staticClass: "text-green"
  }, [(_vm.statusType === 'YAML import') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.yamlSuccess')))]) : (_vm.statusType === 'Recompute group') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.recomputeSuccess')))]) : _vm._e(), _vm._v(" "), (_vm.statusType === 'Recompute group') ? _c('button', {
    staticClass: "btn btn-default createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDetailsModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.details')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refreshGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.refresh')))])]) : _c('div', [_c('span', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.pleaseWait')) + ".\n              "), (_vm.statusType === 'YAML import') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.yamlProgress')))]) : (_vm.statusType === 'Recompute group') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.recomputeProgress')))]) : _vm._e(), _vm._v(" "), (_vm.statusProgress < 100) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.progress')) + ": " + _vm._s(_vm.statusProgress) + "%")]) : _vm._e()]), _vm._v(" "), _c('pulse-loader', {
    staticClass: "loader",
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1)]) : _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseCreateSubgroup(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.createSubGroup')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddExam($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.exams.createExam')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleReorderSubgroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.reorder')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.recomputeGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.recomputeGroup')))]), _vm._v(" "), (_vm.sid == 'root') ? _c('button', {
    staticClass: "btn btn-success createBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openImport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.importStructure')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success createBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.exportGroup')))]), _vm._v(" "), (_vm.sid == 'root') ? _c('button', {
    staticClass: "btn btn-success createBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToGradebook()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.gradebook.title')))]) : _vm._e()])]), _vm._v(" "), (!_vm.colCS) ? _c('div', {
    staticClass: "small-box-footer"
  }, [_c('br'), _vm._v(" "), _c('createsubgroup', {
    attrs: {
      "sid": _vm.sid,
      "gid": _vm.gid
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.hideGroups) ? _c('div', [((!_vm.areAnyExercises || _vm.seznamPodskupin.length > 0)) ? _c('div', [(_vm.detectMobile()) ? _c('div', [_c('div', {
    class: ['no-padding-box', 'content', _vm.possibleColors[3], 'subgroup-box', 'group-box', 'info-box', 'containter-fluid'],
    staticStyle: {
      "padding": "10px",
      "margin-bottom": "0px !important"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExamsShown()
      }
    }
  }, [_c('h3', {
    staticClass: "small-margin-text info-box-number",
    class: {
      'left-margin-text': !_vm.detectMobile()
    }
  }, [_vm._m(0), _vm._v("\n          " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzes')) + "\n          "), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.showRatingQuizSelection($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pages.subgroups.generatedQuiz')) + "\n            ")])])]), _vm._v(" "), (_vm.examsOpened) ? _c('span', {
    staticClass: "small-margin-text progress-description",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')) + "\n        ")]) : _c('span', {
    staticClass: "small-margin-text progress-description",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.sid != 'root' && !_vm.detectMobile()) ? _c('div', [_c('div', {
    class: ['no-padding-box', 'content', _vm.possibleColors[3], 'subgroup-box', 'info-box', 'containter-fluid'],
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExamsShown()
      }
    }
  }, [_c('div', {
    staticClass: "group-box"
  }, [_c('span', {
    staticClass: "small-icon info-box-icon",
    class: []
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h3', {
    staticClass: "small-margin-text info-box-number left-margin-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzes')) + "\n              "), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.showRatingQuizSelection($event)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('pages.subgroups.generatedQuiz')) + "\n                ")])])]), _vm._v(" "), (_vm.examsOpened) ? _c('span', {
    staticClass: "left-margin-text small-margin-text progress-description",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')) + "\n            ")]) : _c('span', {
    staticClass: "left-margin-text small-margin-text progress-description",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')) + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.sid == 'root' && !_vm.detectMobile()) ? _c('div', {
    staticClass: "group-box small-box info-box containter-full",
    class: [_vm.possibleColors[3]],
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExamsShown()
      }
    }
  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.showRatingQuizSelection($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pages.subgroups.generatedQuiz')) + "\n            ")])]), _vm._v(" "), _c('h3', {
    staticClass: "info-box-number"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzes')) + "\n          ")]), _vm._v(" "), (_vm.examsOpened) ? _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')) + "\n          ")]) : _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-group",
    staticStyle: {
      "margin-bottom": "15px !important"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "0px !important"
    }
  }, [(_vm.seznamKvizov && _vm.seznamKvizov.length <= 0) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('pages.subgroups.noQuizzes')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.seznamKvizov), function(kviz, index) {
    return _c('div', {
      key: 'kviz-' + kviz.id
    }, [(_vm.detectMobile()) ? _c('div', [_c('div', {
      class: ['no-padding-box', 'content', kviz.isExam ? _vm.possibleColors[2] : _vm.possibleColors[3], 'subgroup-box', 'group-box', 'info-box', 'containter-fluid'],
      staticStyle: {
        "padding": "10px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExamInfo(kviz)
        }
      }
    }, [_c('div', {
      staticClass: "btn-group pull-right"
    }, [(_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.editTopic(kviz, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.$refs.examResultsPreview.showCurrentResults(kviz.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-archive"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.exportCSV(kviz.id)
        }
      }
    }, [_vm._v("\n                      .csv\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showExamResults(kviz)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('pages.exams.showAttempts')) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticClass: "small-margin-text info-box-number",
      class: {
        'left-margin-text': !_vm.detectMobile()
      }
    }, [(_vm.detectMobile()) ? _c('span', [(kviz.isExam) ? _c('i', {
      staticClass: "fa fa-calendar"
    }) : _c('i', {
      staticClass: "fa fa-hourglass"
    })]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm._f("pickTranslation")(kviz.title)) + "\n                    "), (!_vm.adminView && kviz.classExams[0] && kviz.classExams[0].isSolving) ? _c('i', {
      staticClass: "fa fa-spinner"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ({
        width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount) * 100 + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "small-margin-text progress-description"
    }, _vm._l((kviz.classExams), function(classExam) {
      return _c('span', {
        key: 'class-exam-' + classExam.id,
        staticClass: "progress-description"
      }, [(_vm.selectedGroup.isOwner) ? _c('span', [_c('b', [_vm._v(_vm._s(classExam.class))])]) : _c('span', [_vm._v(_vm._s(_vm.$t('pages.group.opensAt')) + ": " + _vm._s(_vm._f("formatDate")(classExam.startsAt)) + " " + _vm._s(_vm.$t('pages.group.duration')) + ": " + _vm._s(classExam.duration / 60 / 1000) + " minut")]), _vm._v(" "), (classExam.publishedAt && _vm.adminView) ? _c('div', {
        staticClass: "pull-right"
      }, [_c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.published')))])]) : _vm._e()])
    }), 0)])]) : (_vm.sid != 'root') ? _c('div', {
      key: kviz.id,
      class: ['no-padding-box', 'content', kviz.isExam ? _vm.possibleColors[2] : _vm.possibleColors[3], 'subgroup-box', 'info-box', 'containter-fluid']
    }, [_c('div', {
      staticClass: "group-box",
      staticStyle: {
        "position": "relative"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExamInfo(kviz)
        }
      }
    }, [(!_vm.detectMobile()) ? _c('span', {
      staticClass: "small-icon info-box-icon",
      class: [],
      staticStyle: {
        "height": "100%",
        "position": "absolute"
      }
    }, [(kviz.isExam) ? _c('i', {
      staticClass: "fa fa-calendar"
    }) : _c('i', {
      staticClass: "fa fa-hourglass"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "btn-group pull-right"
    }, [(_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.editTopic(kviz, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.$refs.examResultsPreview.showCurrentResults(kviz.id, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-archive"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.exportCSV(kviz.id)
        }
      }
    }, [_vm._v("\n                        .csv\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showExamResults(kviz)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('pages.exams.showAttempts')) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticClass: "small-margin-text info-box-number",
      class: {
        'left-margin-text': !_vm.detectMobile()
      }
    }, [(_vm.detectMobile()) ? _c('span', [(kviz.isExam) ? _c('i', {
      staticClass: "fa fa-calendar"
    }) : _c('i', {
      staticClass: "fa fa-hourglass"
    })]) : _vm._e(), _vm._v("\n                      " + _vm._s(index + 1) + ". " + _vm._s(_vm._f("pickTranslation")(kviz.title)) + "\n                      "), (!_vm.adminView && kviz.classExams[0] && kviz.classExams[0].isSolving) ? _c('i', {
      staticClass: "fa fa-spinner"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress",
      staticStyle: {
        "margin-left": "60px"
      }
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ({
        width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount) * 100 + '%'
      })
    })]), _vm._v(" "), (kviz.classExams.length === 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((kviz.classExams), function(classExam) {
      return _c('span', {
        key: 'e-progress-' + classExam.id,
        staticClass: "small-margin-text progress-description",
        class: {
          'left-margin-text': !_vm.detectMobile()
        }
      }, [(_vm.selectedGroup.isOwner) ? _c('span', [_c('b', [_vm._v(_vm._s(classExam.class))]), _vm._v(" - ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$t('pages.group.opensAt')) + ": " + _vm._s(_vm._f("formatDate")(classExam.startsAt)) + " " + _vm._s(_vm.$t('pages.group.duration')) + ": " + _vm._s(classExam.duration / 60 / 1000) + " minut\n                      "), (classExam.publishedAt && _vm.adminView) ? _c('div', {
        staticClass: "pull-right"
      }, [_c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.published')))])]) : _vm._e()])
    })], 2)])]) : _c('div', {
      staticClass: "group-box small-box info-box containter-full",
      class: [kviz.isExam ? _vm.possibleColors[2] : _vm.possibleColors[3]],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExamInfo(kviz)
        }
      }
    }, [_c('div', [_c('span', {
      staticClass: "info-box-icon",
      staticStyle: {
        "position": "absolute"
      }
    }, [(kviz.isExam) ? _c('i', {
      staticClass: "fa fa-calendar"
    }) : _c('i', {
      staticClass: "fa fa-hourglass"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('div', {
      staticClass: "btn-group pull-right"
    }, [(_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-top": "0.5em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.editTopic(kviz, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-top": "0.5em",
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.navigateToFlow(kviz.id)
        }
      }
    }, [_vm._v("\n                        Poglej potek izpita\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-top": "0.5em",
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.$refs.examResultsPreview.showCurrentResults(kviz.id, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-archive"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-top": "0.5em",
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.exportCSV(kviz.id)
        }
      }
    }, [_vm._v("\n                        .csv\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-top": "0.5em",
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showExamResults(kviz)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('pages.exams.showAttempts')) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticClass: "info-box-number"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("pickTranslation")(kviz.title)) + "\n                      "), (!_vm.adminView && kviz.classExams[0] && kviz.classExams[0].isSolving) ? _c('i', {
      staticClass: "fa fa-spinner"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ({
        width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount) * 100 + '%'
      })
    })]), _vm._v(" "), _vm._l((kviz.classExams), function(classExam) {
      return _c('span', {
        staticClass: "progress-description"
      }, [(_vm.selectedGroup.isOwner) ? _c('span', [_c('b', [_vm._v(_vm._s(classExam.class))]), _vm._v(" - ")]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$t('pages.group.opensAt')) + ": " + _vm._s(_vm._f("formatDate")(classExam.startsAt)) + " " + _vm._s(_vm.$t('pages.group.duration')) + ": " + _vm._s(classExam.duration / 60 / 1000) + " minut\n                      "), (classExam.publishedAt && _vm.adminView) ? _c('div', {
        staticClass: "pull-right"
      }, [_c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.published')))])]) : _vm._e()])
    })], 2)]), _vm._v(" "), (kviz.showEdit) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_c('editsubgroup', {
      attrs: {
        "podgrupa": kviz
      }
    })], 1) : _vm._e(), _vm._v(" "), (kviz.showOrder) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_c('orderexer', {
      attrs: {
        "podgrupa": kviz
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "modal modal-default fade",
      attrs: {
        "id": 'kviz' + kviz.id
      }
    }, [_c('div', {
      staticClass: "modal-dialog"
    }, [_c('div', {
      staticClass: "modal-content"
    }, [_c('div', {
      staticClass: "modal-header"
    }, [_vm._m(2, true), _vm._v(" "), _c('h4', {
      staticClass: "modal-title"
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.examinationInfo')))])]), _vm._v(" "), _c('div', {
      staticClass: "modal-body"
    }, [(kviz && kviz.classExams && kviz.classExams.length > 0) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(" " + _vm._s(kviz.title))]), _vm._v(" "), (kviz.classExams[0].maxRetries != 0) ? _c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.allowedAttempts')) + ": " + _vm._s(kviz.classExams[0].maxRetries) + " (" + _vm._s(kviz.classExams[0].maxRetries - kviz.classExams[0].retriesCount) + " " + _vm._s(_vm.$t('pages.exams.remaining')) + ")")]) : _c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.allowedAttempts')) + ": " + _vm._s(_vm.$t('pages.exams.noLimit')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.start')) + ": " + _vm._s(_vm._f("formatDate")(kviz.classExams[0].startsAt)))]), _vm._v(" "), (kviz.classExams[0].finishesAt != null) ? _c('p', [_vm._v(" " + _vm._s(_vm.$t('pages.exams.finishTime')) + ": " + _vm._s(_vm._f("formatDate")(kviz.classExams[0].finishesAt)) + " ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('pages.group.duration')) + ": " + _vm._s(kviz.classExams[0].duration / 1000 / 60) + " min")]), _vm._v(" "), (kviz.show_one_exercise) ? _c('p', {
      staticClass: "text-red",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.oneExerciseAtATimeWarning')))]) : _vm._e()]), _vm._v(" "), (_vm.attemptHistory.length > 0) ? _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box-body no-padding"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "3em"
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.attempt')))]), _vm._v(" "), (!_vm.detectMobile()) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.startedAt')))]) : _vm._e(), _vm._v(" "), (!_vm.detectMobile()) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.finishedAt')))]) : _vm._e(), _vm._v(" "), (_vm.detectMobile()) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.status')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.grade')))])]), _vm._v(" "), _vm._l((_vm.attemptHistory), function(poskus, i) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), (!_vm.detectMobile()) ? _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(poskus.startedAt)))]) : _vm._e(), _vm._v(" "), (!_vm.detectMobile()) ? _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(poskus.finishedAt)))]) : _vm._e(), _vm._v(" "), (_vm.detectMobile() && kviz.classExams[0].isSolving && kviz.classExams[0].examId === poskus.id) ? _c('td', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.inProgress')))]) : _vm._e(), _vm._v(" "), (_vm.detectMobile() && !(kviz.classExams[0].isSolving && kviz.classExams[0].examId === poskus.id)) ? _c('td', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.finished')))]) : _vm._e(), _vm._v(" "), (poskus.points != null && poskus.maxPoints) ? _c('td', [_c('div', {
        staticClass: "progress progress-xs"
      }, [(100 * poskus.points / poskus.maxPoints >= 50) ? _c('div', {
        staticClass: "progress-bar progress-bar-green",
        style: ({
          width: (100 * poskus.points / poskus.maxPoints) + '%'
        })
      }) : _c('div', {
        staticClass: "progress-bar progress-bar-danger",
        style: ({
          width: (100 * poskus.points / poskus.maxPoints) + '%'
        })
      })])]) : _c('td', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.unavailable')))]), _vm._v(" "), (poskus.points != null && poskus.maxPoints) ? _c('td', [((100 * poskus.points / poskus.maxPoints) >= 50) ? _c('span', {
        staticClass: "badge bg-green"
      }, [_vm._v(_vm._s((100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'))]) : _c('span', {
        staticClass: "badge bg-red"
      }, [_vm._v(_vm._s((100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'))])]) : _vm._e(), _vm._v(" "), (kviz.showResult) ? _c('td', {
        staticClass: "pull-right",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.showFullAttempt(poskus, kviz)
          }
        }
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.showAttempt')))])]) : _c('td')])
    })], 2)])])]) : _vm._e(), _vm._v(" "), (kviz.classExams[0].passwordRequired) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(_vm._s(_vm.$t('pages.register.password')) + ":")]), _vm._v(" "), _c('div', {}, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.modalStartExam.examPassword),
        expression: "modalStartExam.examPassword"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "password"
      },
      domProps: {
        "value": (_vm.modalStartExam.examPassword)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.modalStartExam, "examPassword", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', [_c('a', {
      staticClass: "btn btn-primary pull-right",
      class: [{
        'disabled': (kviz.classExams[0].maxRetries > 0 && kviz.classExams[0].maxRetries - kviz.classExams[0].retriesCount <= 0 && !_vm.adminView)
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.zacniResevanjeIzpita(kviz)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.$t('pages.exams.begin')) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": ""
      }
    }, [(_vm.modalStartExam.statusText !== '') ? _c('div', {
      staticClass: "help-block text-center"
    }, [_vm._v(_vm._s(_vm.modalStartExam.statusText))]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
      staticClass: "modal modal-default fade",
      attrs: {
        "id": 'error-kviz' + kviz.id
      }
    }, [_c('div', {
      staticClass: "modal-dialog"
    }, [_c('div', {
      staticClass: "modal-content"
    }, [_c('div', {
      staticClass: "modal-header"
    }, [_vm._m(3, true), _vm._v(" "), _c('h4', {
      staticClass: "modal-title"
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.examinationInfo')))])]), _vm._v(" "), _c('div', {
      staticClass: "modal-body"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('pages.exams.examNotScheduled')) + "\n                      "), _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToEditExam(kviz)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.goToEditExam')))])])])])])])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.seznamPodskupin), function(subgroup, jIndeks) {
    return (_vm.sid === 'root' && !_vm.detectMobile()) ? _c('div', {
      key: 'podskupina-' + jIndeks,
      staticClass: "small-box info-box containter-full",
      class: [_vm.defaultGColor]
    }, [_c('div', {
      staticClass: "group-box ",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExercises(subgroup)
        }
      }
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [(subgroup.subgroupsCount && subgroup.subgroupsCount != 0) ? _c('i', {
      staticClass: "fa fa-folder"
    }) : (subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0) ? _c('i', {
      staticClass: "fa fa-pencil"
    }) : _c('i', {
      staticClass: "fa fa-question"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('h3', {
      staticClass: "info-box-number"
    }, [_c('div', {
      staticClass: "dropdown pull-right",
      attrs: {
        "id": 'dropdown-' + jIndeks
      }
    }, [(subgroup.youtube_link != null) ? _c('button', {
      staticClass: "btn btn-secondary pull-right",
      staticStyle: {
        "margin-top": "0.5em",
        "margin-left": "0.1em"
      },
      attrs: {
        "type": "button",
        "id": "youtubeLinkButton"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleVideo(subgroup.youtube_link, subgroup.youtube_time)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-play"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('button', {
      staticClass: "btn btn-secondary dropdown-toggle",
      attrs: {
        "id": 'dropdownMenuButton-' + jIndeks,
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "data-toggle": "dropdown"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleDropdown(jIndeks, _vm.seznamPodskupin.length)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-cog"
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-caret-down"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.jeAdmin) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showExercisesIdentifiers(subgroup)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.showExercises')))])]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.adminView) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.toggleShowEdit(subgroup, jIndeks);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editSubgroup')))]) : _vm._e()]), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && !subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.orderTopic(subgroup, jIndeks)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editExercises')))])]) : _vm._e(), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.showEditRules(subgroup, jIndeks)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.editRules')))])]) : _vm._e(), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.showPreview(subgroup, _vm.indeks)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.previewExercises')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(subgroup.name))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ({
        width: (subgroup.totalSolvedQuestionsCount / subgroup.totalQuestionsCount) * 100 + '%'
      })
    })]), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0)) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(subgroup.totalSolvedQuestionsCount) + "/" + _vm._s(subgroup.totalQuestionsCount) + " questions (total " + _vm._s(subgroup.exercisesCount) + " exercises)")]) : _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(subgroup.totalSolvedQuestionsCount) + "/" + _vm._s(subgroup.totalQuestionsCount) + " questions (total " + _vm._s(subgroup.subgroupsCount) + " subgroups)")]), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n            " + _vm._s(_vm._f("pickTranslation")(subgroup.description)) + " \n             "), (_vm.jeAdmin) ? _c('span', [_vm._v("\n            (" + _vm._s(subgroup.exercisesCount) + " exercises)\n          "), _c('br'), _vm._v(" "), (_vm.forWhichSubgroup == subgroup.name) ? _c('span', _vm._l((_vm.exerciesesIdentifiers), function(el) {
      return _c('span', [_vm._v(_vm._s(el)), _c('br')])
    }), 0) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (subgroup.showEdit) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_c('editsubgroup', {
      attrs: {
        "podgrupa": subgroup
      }
    })], 1) : _vm._e(), _vm._v(" "), (subgroup.showOrder) ? _c('div', {
      staticClass: "small-box-footer"
    }, [(subgroup.dynamic) ? _c('editRules', {
      ref: "editRules",
      refInFor: true,
      attrs: {
        "podgrupa": subgroup
      }
    }) : _c('orderexer', {
      attrs: {
        "podgrupa": subgroup
      }
    })], 1) : _vm._e(), _vm._v(" "), (subgroup.dynamic && subgroup.showPreview) ? _c('div', [(subgroup.dynamic) ? _c('previewExer', {
      ref: "previewExercise",
      refInFor: true,
      attrs: {
        "podgrupa": subgroup
      }
    }) : _vm._e()], 1) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.hideGroups) ? _c('div', [_c('div', _vm._l((_vm.seznamPodskupin), function(subgroup, index) {
    return ((_vm.adminView || subgroup.visible) && (_vm.sid != 'root' || _vm.detectMobile())) ? _c('div', {
      key: 'show-evercises-' + subgroup.id,
      class: ['no-padding-box', 'content', _vm.defaultGColor, 'subgroup-box', 'info-box', 'containter-fluid']
    }, [_c('div', {
      staticClass: "group-box",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExercises(subgroup)
        }
      }
    }, [(!_vm.detectMobile()) ? _c('span', {
      staticClass: "small-icon info-box-icon",
      class: []
    }, [(subgroup.subgroupsCount && subgroup.subgroupsCount != 0) ? _c('i', {
      staticClass: "fa fa-folder"
    }) : (subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0) ? _c('i', {
      staticClass: "fa fa-pencil"
    }) : _c('i', {
      staticClass: "fa fa-question"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [(subgroup.youtube_link != null) ? _c('button', {
      staticClass: "btn btn-default pull-right",
      staticStyle: {
        "margin-left": "0.25em"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleVideo(subgroup.youtube_link, subgroup.youtube_time)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-play"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminView) ? _c('div', {
      staticClass: "dropdown pull-right",
      attrs: {
        "id": 'dropdown-' + index
      }
    }, [_c('button', {
      staticClass: "btn btn-secondary btn-sm dropdown-toggle",
      attrs: {
        "id": 'dropdownMenuButton-' + index,
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "data-toggle": "dropdown"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleDropdown(index, _vm.seznamPodskupin.length)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-cog"
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-caret-down"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.jeAdmin) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.showExercisesIdentifiers(subgroup)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.showExercises')))])]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.adminView) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.toggleShowEdit(subgroup, index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editSubgroup')))]) : _vm._e()]), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && !subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.orderTopic(subgroup, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editExercises')))])]) : _vm._e(), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.showEditRules(subgroup, _vm.indeks)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.editRules')))])]) : _vm._e(), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && _vm.adminView && subgroup.dynamic) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.closeAllDropdowns(_vm.seznamPodskupin.length);
          _vm.showPreview(subgroup, _vm.indeks)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.previewExercises')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "small-margin-text info-box-number",
      class: {
        'left-margin-text': !_vm.detectMobile()
      }
    }, [(_vm.detectMobile()) ? _c('span', [(subgroup.subgroupsCount && subgroup.subgroupsCount != 0) ? _c('i', {
      staticClass: "fa fa-folder"
    }) : (subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0) ? _c('i', {
      staticClass: "fa fa-pencil"
    }) : _c('i', {
      staticClass: "fa fa-question"
    })]) : _vm._e(), _vm._v("\n          " + _vm._s(index + 1) + ". " + _vm._s(_vm._f("pickTranslation")(subgroup.name)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ({
        width: (subgroup.totalSolvedQuestionsCount / subgroup.totalQuestionsCount) * 100 + '%'
      })
    })]), _vm._v(" "), ((!subgroup.subgroupsCount || subgroup.subgroupsCount == 0)) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(subgroup.totalSolvedQuestionsCount) + "/" + _vm._s(subgroup.totalQuestionsCount) + " questions (total " + _vm._s(subgroup.exercisesCount) + " exercises)")]) : _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(subgroup.totalSolvedQuestionsCount) + "/" + _vm._s(subgroup.totalQuestionsCount) + " questions (total " + _vm._s(subgroup.subgroupsCount) + " subgroups)")]), _vm._v(" "), _c('span', {
      staticClass: "small-margin-text progress-description",
      class: {
        'left-margin-text': !_vm.detectMobile()
      }
    }, [_vm._v("\n\n          " + _vm._s(_vm._f("pickTranslation")(subgroup.description)) + "  \n          "), (_vm.jeAdmin) ? _c('span', [_vm._v("\n          (" + _vm._s(subgroup.exercisesCount) + " exercises)\n          "), _c('br'), _vm._v(" "), (_vm.forWhichSubgroup == subgroup.name) ? _c('span', _vm._l((_vm.exerciesesIdentifiers), function(el) {
      return _c('span', [_vm._v(_vm._s(el)), _c('br')])
    }), 0) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (subgroup.showOrder) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_c('div', {
      staticStyle: {
        "overflow": "auto",
        "width": "100%",
        "text-align": "center"
      }
    }, [(subgroup.dynamic) ? _c('editRules', {
      ref: "editRules",
      refInFor: true,
      attrs: {
        "podgrupa": subgroup
      }
    }) : _c('orderexer', {
      attrs: {
        "podgrupa": subgroup
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (subgroup.dynamic && subgroup.showPreview) ? _c('div', [(subgroup.dynamic) ? _c('previewExer', {
      ref: "previewExercise",
      refInFor: true,
      attrs: {
        "podgrupa": subgroup
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (subgroup.showEdit) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_c('editsubgroup', {
      attrs: {
        "podgrupa": subgroup
      }
    })], 1) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.seznamPodskupin && _vm.seznamPodskupin.length > 2) ? _c('div', [(_vm.detectMobile()) ? _c('div', {
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "600px",
      "min-height": "600px"
    }
  }, [_c('spider-chart', {
    attrs: {
      "seznamPodskupin": _vm.seznamPodskupin
    }
  })], 1)]) : _c('spider-chart', {
    attrs: {
      "seznamPodskupin": _vm.seznamPodskupin
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-addExam"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(4), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.createExam')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group exam-name"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.name')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.examName),
      expression: "examName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.examName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.examName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExam($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.createExam')))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-show-exercise"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.preview')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('exercise', {
    attrs: {
      "bareBonesExercise": _vm.CelotnaNaloga
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), (this.adminView) ? _c('div', {
    staticClass: "modal modal-default",
    attrs: {
      "id": "modal-exercises-add",
      "data-target": "#modal-exercises-add"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-primary"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.searchExercises')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('library')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer bg-primary"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExercisesModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.cancel')))]), _vm._v(" "), (_vm.selectedExercises && _vm.selectedExercises.length > 0) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExercisesBulk()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.add')))]) : _c('button', {
    staticClass: "btn btn-default disabled"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.add')))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'importStructure'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(7), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.importStructure')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [
    [(_vm.isInitial || _vm.isSaving) ? _c('form', {
      staticClass: "uploadForm",
      attrs: {
        "enctype": "multipart/form-data",
        "novalidate": ""
      }
    }, [_c('div', {
      staticClass: "dropbox"
    }, [_c('input', {
      staticClass: "input-file",
      attrs: {
        "type": "file",
        "name": "file",
        "disabled": _vm.isSaving,
        "accept": ".yaml"
      },
      on: {
        "change": function($event) {
          _vm.save();
          _vm.fileCount = $event.target.files.length
        }
      }
    }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                  " + _vm._s(_vm.$t('pages.subgroups.uploadSentence'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.uploadSentence2')) + "\n                ")]) : _vm._e()])]) : _vm._e()]
  ], 2)])])]), _vm._v(" "), (_vm.adminView) ? _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'examHistoryModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(8), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.allExams')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.startedAt')))]), _vm._v(" "), (!_vm.detectMobile()) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.finishedAt')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.grade')))])]), _vm._v(" "), _vm._l((_vm.attemptHistory), function(poskus, i) {
    return _c('tr', {
      key: 'ah-' + poskus
    }, [(poskus.user) ? _c('td', [_vm._v(_vm._s(poskus.user.firstName) + " " + _vm._s(poskus.user.lastName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(poskus.startedAt)))]), _vm._v(" "), (!_vm.detectMobile()) ? _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(poskus.finishedAt)))]) : _vm._e(), _vm._v(" "), (poskus.points != null && poskus.maxPoints) ? _c('td', [_c('div', {
      staticClass: "progress progress-xs"
    }, [(100 * poskus.points / poskus.maxPoints >= 50) ? _c('div', {
      staticClass: "progress-bar progress-bar-green",
      style: ({
        width: (100 * poskus.points / poskus.maxPoints) + '%'
      })
    }) : _c('div', {
      staticClass: "progress-bar progress-bar-danger",
      style: ({
        width: (100 * poskus.points / poskus.maxPoints) + '%'
      })
    })])]) : _c('td', [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.unavailable')))]), _vm._v(" "), _c('td', [(poskus.points != null && poskus.maxPoints) ? _c('div', [((100 * poskus.points / poskus.maxPoints) >= 50) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v(_vm._s((100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'))]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_vm._v(_vm._s((100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showExamAttempt(poskus.id)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.attemptHistory.showAttempt')))])])])
  })], 2)])])]), _vm._v(" "), _c('div', {}, [(_vm.modalStartExam.statusText !== '') ? _c('div', {
    staticClass: "help-block text-center"
  }, [_vm._v(_vm._s(_vm.modalStartExam.statusText))]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('exam-results-preview', {
    ref: "examResultsPreview"
  }), _vm._v(" "), (_vm.adminView) ? _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'reorderSubgroupsModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(9), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.reorder')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('reorder-subgroups', {
    attrs: {
      "podskupine": _vm.seznamPodskupin,
      "skupinaId": _vm.gid,
      "podskupinaId": _vm.sid
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'selectSubgroupsModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(10), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingQuiz')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.ratingQuizInfo')))]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "margin": "20px 0 10px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectSubgroups')))]), _vm._v(" "), (_vm.loadingSubgroups) ? _c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "form-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.filteredSubgroups), function(subgroup) {
    return _c('div', {
      key: subgroup.id
    }, [_c('div', {
      style: ('margin-left: ' + (2 * subgroup.nivo) + 'em')
    }, [(subgroup.list) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.izbranePodskupine),
        expression: "izbranePodskupine"
      }],
      attrs: {
        "type": "checkbox",
        "id": subgroup.id
      },
      domProps: {
        "value": subgroup.id,
        "checked": Array.isArray(_vm.izbranePodskupine) ? _vm._i(_vm.izbranePodskupine, subgroup.id) > -1 : (_vm.izbranePodskupine)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.izbranePodskupine,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = subgroup.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.izbranePodskupine = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.izbranePodskupine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.izbranePodskupine = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": subgroup.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleSubgroup(subgroup)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(!subgroup.list ? _vm.expandedSymbol(subgroup) : '') + " " + _vm._s(_vm._f("pickTranslation")(subgroup.name)) + "\n                    ")]), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, true)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.addAll')) + ")\n                    ")]) : _vm._e(), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, false)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.removeAll')) + ")\n                    ")]) : _vm._e()])])
  }), 0)], 1)], _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectDuration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.izbranoTrajanje),
      expression: "izbranoTrajanje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.izbranoTrajanje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min")])])]), _vm._v(" "), (_vm.adminView) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createQuiz),
      expression: "createQuiz"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createQuiz) ? _vm._i(_vm.createQuiz, null) > -1 : (_vm.createQuiz)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createQuiz,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.createQuiz = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.createQuiz = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.createQuiz = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.createQuizForOtherUsers')) + "\n          ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.createQuiz) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startRatingQuiz($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.createQuiz')))]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startRatingQuiz($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.startQuiz')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-addRule"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(11), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.addRule')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "small-box-footer"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sId),
      expression: "sId"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.subgroups.editRules.identifier')
    },
    domProps: {
      "value": (_vm.sId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stitle),
      expression: "stitle"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.title')
    },
    domProps: {
      "value": (_vm.stitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sauthor),
      expression: "sauthor"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.author')
    },
    domProps: {
      "value": (_vm.sauthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sauthor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-xs-10 margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssource),
      expression: "ssource"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.source')
    },
    domProps: {
      "value": (_vm.ssource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssource = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin col-xs-3"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sowner),
      expression: "sowner"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sowner) ? _vm._i(_vm.sowner, null) > -1 : (_vm.sowner)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sowner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sowner = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sowner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sowner = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.exerciseList.owner')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin col-xs-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.tags,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.tags')
    },
    model: {
      value: (_vm.stags),
      callback: function($$v) {
        _vm.stags = $$v
      },
      expression: "stags"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sTagFilter === 'or'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateTagFilter('or')
      }
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    class: {
      'bg-blue': _vm.sTagFilter === 'and'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateTagFilter('and')
      }
    }
  }, [_vm._v("and")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.tags,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.tagsExclude')
    },
    model: {
      value: (_vm.stagsExclude),
      callback: function($$v) {
        _vm.stagsExclude = $$v
      },
      expression: "stagsExclude"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.lngs,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.languages')
    },
    model: {
      value: (_vm.slangs),
      callback: function($$v) {
        _vm.slangs = $$v
      },
      expression: "slangs"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 margin"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.options.types,
      "label": "name",
      "placeholder": _vm.$t('pages.exerciseList.placeholders.types')
    },
    model: {
      value: (_vm.stypes),
      callback: function($$v) {
        _vm.stypes = $$v
      },
      expression: "stypes"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.editRuleId !== null) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editRule($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.editRule')))]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewRule($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.addRule')))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-danger fade",
    attrs: {
      "id": "modal-beforeDelete"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(12), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.deleteRuleModal')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.confirmDeleteMessage')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteRule($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.deleteConfirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDeleteRule($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.editRules.deleteCancel')))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), (_vm.adminView) ? _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "detailsModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(13), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.statusType))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.statusProgress == -1) ? _c('div', {
    staticClass: "text-red"
  }, [(_vm.statusType === 'YAML import') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.yamlError')))]) : (_vm.statusType === 'Recompute group') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.recomputeError')))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.statusMessage))])]) : (_vm.statusProgress == 100) ? _c('div', {
    staticClass: "text-green"
  }, [(_vm.statusType === 'YAML import') ? _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.yamlSuccess')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.statusMessage))])]) : (_vm.statusType === 'Recompute group') ? _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('pages.subgroups.recomputeSuccess')))]), _vm._v(" "), _vm._l((_vm.statusMessage), function(subgroup, index) {
    return _c('small', {
      key: 'status-' + index
    }, [_vm._v(_vm._s(subgroup)), _c('br')])
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.close')))])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('exercises-list', {
    attrs: {
      "examExercises": _vm.examExercises.exercises,
      "selectedGroup": _vm.selectedGroup
    }
  })], 1), _vm._v(" "), _vm._m(14)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-clock-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "videoModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('iframe', {
    attrs: {
      "width": "789",
      "height": "444",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f46e6e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f46e6e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/Exercises.vue
// module id = 1384
// module chunks = 1